import { IPlanificationProfileScheduler } from '@/entity/planification/planification-profile-scheduler';
import { dateToString, IRetrieveWorkoutKey, retrieveWorkoutValues } from '../calendar-helper';

export interface ConfigManual {
  key: string;
  workoutKey: IRetrieveWorkoutKey;
  workoutDate: Date;
  state: 'persistant-to-remove'
}

export const addOrDeleteSelectedConfig = (key: string, configs: ConfigManual[]) => {
    const workoutKeys = retrieveWorkoutValues(key);
    if (!workoutKeys) {
        return;
    }
    const date = new Date(workoutKeys.keyDate);
    const indexToCheck = configs.findIndex(c => c.key === key);
    if (indexToCheck > -1) {
        configs.splice(indexToCheck, 1);
    } else {
        configs.push({
            key: key,
            workoutKey: workoutKeys,
            workoutDate: date,
            state: 'persistant-to-remove'
        });
    }
};

export const replaceWorkoutDateByManualDate = (configManual: ConfigManual[], profiles: IPlanificationProfileScheduler[]): IPlanificationProfileScheduler[] => {
    const phaseProfileIds = uniquePhaseProfile(profiles);
    const result: IPlanificationProfileScheduler[] = [];
    phaseProfileIds.forEach((phaseProfile) => {
        const profile = profiles.find(
            (p) =>
                p.contractLineId === phaseProfile.contractLineId && p.indexInPhase === phaseProfile.indexInPhase
        );
        if (profile) {
            profile.planificationPhaseProfileWorkDays.forEach((wd) => {
                const manual = configManual.find(
                    (cm) =>
                        cm.workoutKey.contractLineId === phaseProfile.contractLineId &&
              cm.workoutKey.indexInPhase === phaseProfile.indexInPhase &&
              dateToString(cm.workoutDate, 'dd/MM/yyyy') === dateToString(wd.date, 'dd/MM/yyyy')
                );
                wd.manual = manual && manual.state === 'persistant-to-remove' ? 'remove' : undefined;
            });
            result.push(profile);
        }
    });
    return result;
};

const uniquePhaseProfile = (profiles: IPlanificationProfileScheduler[]): { contractLineId: number; indexInPhase: number; }[] => {
    return profiles
        .map((cm) => ({ contractLineId: cm.contractLineId, indexInPhase: cm.indexInPhase }))
        .reduce<{ contractLineId: number; indexInPhase: number }[]>((acc, current) => {
            if (
                !acc.find(
                    (a) =>
                        a.contractLineId === current.contractLineId && a.indexInPhase === current.indexInPhase
                )
            ) {
                acc.push(current);
            }
            return acc;
        }, []);
};
